import type { Cart } from '@grafikr/shopify-typescript/type/json/Cart';
import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node, { emitter }) => {
  emitter.on('cart:updated', (cart: Cart) => {
    node.hidden = cart.item_count === 0;

    if (node.hasAttribute('data-wrap')) {
      node.textContent = `(${cart.item_count})`;
    } else {
      node.textContent = cart.item_count.toString();
    }
  });
  emitter.on('cart:updated:no-drawer', (cart: Cart) => {
    node.hidden = cart.item_count === 0;

    if (node.hasAttribute('data-wrap')) {
      node.textContent = `(${cart.item_count})`;
    } else {
      node.textContent = cart.item_count.toString();
    }
  });
};

export default Component;
